import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import "./BigOInfo.css";

const BigOInfo = ({
  isOptimal,
  timeComplexity,
  spaceComplexity,
  handleLevelChange,
  problemName,
  codeSnippet,
  handleCloseBigO,
}) => {
  const [loadingExplanation, setLoadingExplanation] = useState(false);

  const handleExplainClick = async () => {
    setLoadingExplanation(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/problems/explainBigO`,
        {
          problemName,
          codeSnippet,
          isOptimal,
          timeComplexity,
          spaceComplexity,
        }
      );

      Swal.fire({
        title: "Big O Breakdown",
        html: `
<div style="font-size: 20px; margin-bottom: 12px; color: #aaa; text-align: center;">
  <strong>Time:</strong> <span style="color: #4fc3f7;">${timeComplexity}</span> &nbsp;&nbsp;&nbsp;
  <strong>Space:</strong> <span style="color: #81c784;">${spaceComplexity}</span>
</div>

          <div style="
            text-align: left;
            font-size: 16px;
            line-height: 1.75;
            padding: 10px 0;
            font-family: 'Fira Code', monospace;
            white-space: normal;
          ">
            ${formatExplanation(response.data.explanation)}
          </div>
        `,
        icon: "info",
        confirmButtonText: "Got it!",
        width: 700,
        background: "#1e1e1e",
        color: "#f1f1f1",
        customClass: {
          popup: "big-o-popup",
        },
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Something went wrong while fetching the explanation.",
      });
    } finally {
      setLoadingExplanation(false);
    }
  };

  const formatExplanation = (text) => {
    // Escape HTML characters first
    const escaped = text
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\n/g, "<br>");
  
    // Then re-inject bold markdown formatting
    return escaped.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
  };
  

  // const formatExplanation = (text) => {
  //   // Preserve paragraphs
  //   const paragraphs = text.split(/\n{2,}/).map((para) => {
  //     // Convert lines with - or * into bullets
  //     if (/^[-*]/.test(para.trim())) {
  //       const bullets = para
  //         .split("\n")
  //         .map((line) => `<li>${line.replace(/^[-*]\s*/, "").trim()}</li>`)
  //         .join("");
  //       return `<ul style="padding-left: 20px; margin: 10px 0;">${bullets}</ul>`;
  //     }

  //     // Convert common titles like "Time Complexity - O(n)"
  //     if (
  //       /^(\d\.\s*)?(Time|Space|Summary|Two|This|In summary|Overall|Explanation)/i.test(
  //         para
  //       )
  //     ) {
  //       return `<p style="margin: 10px 0;"><strong>${para.trim()}</strong></p>`;
  //     }

  //     // Inline code highlighting for variable names like `a`, `s`, etc.
  //     const withCode = para.replace(/`([^`]+)`/g, "<code>$1</code>");

  //     return `<p style="margin: 10px 0;">${withCode}</p>`;
  //   });

  //   return paragraphs.join("\n");
  // };

  return (
    <div className="big-o-notation-view">
      <button className="close-big-o-button" onClick={handleCloseBigO}>
        ❌
      </button>
      <div className="optimal-info">
        {isOptimal ? (
          <div className="optimal-text">✅ This is the optimal solution.</div>
        ) : (
          <div className="non-optimal-text">
            ⚠️ This is a non-optimal solution.
          </div>
        )}
      </div>

      <div className="complexity-info">
        <div className="complexity-card">
          <h4>Time Complexity</h4>
          <p className="complexity-value">{timeComplexity}</p>
        </div>
        <div className="complexity-card">
          <h4>Space Complexity</h4>
          <p className="complexity-value">{spaceComplexity}</p>
        </div>
      </div>

      <div className="big-o-buttons">
        <button
          className={`big-o-action-button ${loadingExplanation ? "loading" : ""}`}
          onClick={handleExplainClick}
          disabled={loadingExplanation}
        >
          {loadingExplanation ? "Loading..." : "🤔 Explain this to me"}
        </button>
        <button
          className="big-o-action-button pulse"
          onClick={() => handleLevelChange("Pro")}
        >
          💻 Code it yourself
        </button>
      </div>
    </div>
  );
};

export default BigOInfo;
